<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  
  <ng-container *ngIf="labelOnTop; else inlineLabel">
    <label for="licenceTypeId-field" class="form-label">Licence Type</label>
    <select
      class="form-select"
      formControlName="licenceTypeId"
      id="licenceTypeId-field"
      name="licenceTypeId-field"
      (change)="selectOnChange($event)"
    >
      <option [ngValue]="0">{{ firstLicenceTypeOption }}</option>
      @for (object of getDropdownDataObjectArray(); track object.id) {
        <option [ngValue]="object.id">{{ object.description }}</option>
      }
    </select>
  </ng-container>

  <ng-template #inlineLabel>
    <div class="d-flex align-items-center gap-2">
      <label for="licenceTypeId-field" class="form-label mb-0">Licence Type</label>
      <select
        class="form-select"
        formControlName="licenceTypeId"
        id="licenceTypeId-field"
        name="licenceTypeId-field"
        style="width:300px !important; flex:0 0 300px;"
        (change)="selectOnChange($event)"
      >
        <option [ngValue]="0">{{ firstLicenceTypeOption }}</option>
        @for (object of getDropdownDataObjectArray(); track object.id) {
          <option [ngValue]="object.id">{{ object.description }}</option>
        }
      </select>
    </div>
  </ng-template>

</form>
